import SelectOptionAsync from 'Component/Common/Select/SelectOptionAsync';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSetupOrder } from 'Services/Features/Order/orderSlice';
import { getTreatment } from 'Services/Features/Treatment/Utils/treatmentUtils'

const SelectTreatmentOrder = () => {
    const dispatch = useDispatch();
    const treatment = useSelector(state => state.order.setupOrder.treatments);

    const filter = useSelector(state => state.treatment.filters);
    const [selectedValue, setSelectedValue] = useState(null);

    const handleChangeCategory = (selectedOption) => {
        setSelectedValue(selectedOption === null ? [] : selectedOption);
        // Extract treatment_id dari setiap selected option
        dispatch(setSetupOrder({ 
            treatment_ids: selectedOption === null ? [] : selectedOption.map(item => item.treatment_id) 
        }));
    };

    useEffect(() => {
        const selectedTreatment = treatment?.length > 0 ? treatment.map((item, index) => ({
            value: `${item.id}_${Date.now()}_${index}`, // Buat value yang unik
            label: item.name,
            treatment_id: item.id // Simpan id asli di sini
        })) : selectedValue;
        setSelectedValue(selectedTreatment);
        dispatch(setSetupOrder({ treatment_ids: treatment?.length > 0 ? treatment.map(item => item.id) : [] }));
    }, []);

    const promiseOptions = (inputValue, callback) => {
        dispatch(getTreatment({
            ...filter,
            'filter[name]': inputValue,
            'sort': 'name',
            'page': 1,
        }))
            .then((response) => {
                const options = response.payload.data.map((item, index) => ({
                    value: `${item.id}_${Date.now()}_${Math.random()}_${index}`, // Value unik dengan random untuk setiap call
                    label: item.name,
                    treatment_id: item.id // ID asli treatment
                }));
                callback(options);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
                callback([]);
            });
    };

    
    return (
        <SelectOptionAsync
            promiseOptions={promiseOptions}
            handleChange={(selectedOption) => handleChangeCategory(selectedOption)}
            selectedValue={selectedValue}
            placeholder="Pilih Layanan"
            isMulti={true}
        />
    )
}

export default SelectTreatmentOrder;
